import { FC } from 'react'
import { AboutShift } from '../../formComponents'

import { useShiftTypesList } from 'screens/Rostering/hooks/useShiftTypesList'

type AboutShiftSectionProps = {
  hideTeamMembers?: boolean
  hideAboutSection?: boolean
  showTeamMembersSelect?: boolean
  formData?: Record<string, any> | undefined
}

export const AboutShiftSection: FC<AboutShiftSectionProps> = ({
  hideTeamMembers,
  hideAboutSection,
  showTeamMembersSelect = false,
  formData,
}) => {
  const { shiftTypes } = useShiftTypesList()

  const shiftPresetPatternTypeOptions = shiftTypes?.map((shift) => ({
    value: shift.id,
    label: shift.name,
  }))

  return (
    <AboutShift
      typeOfShiftOptions={shiftPresetPatternTypeOptions}
      hideTeamMembers={hideTeamMembers}
      hideAboutSection={hideAboutSection}
      showTeamMembersSelect={showTeamMembersSelect}
      formData={formData}
    />
  )
}
